import { getCookie } from './utils';

class User {
  private tenantId = 'tenantId';
  private tokenKey = 'chatbot-admin-token';
  private store: any = window.localStorage;
  setTenantId(tenantId: any) {
    this.store && this.store.setItem(this.tenantId, tenantId);
  }
  removeTenantId() {
    this.store && this.store.removeItem(this.tenantId);
  }
  getTenantId() {
    return this.store && this.store.getItem(this.tenantId);
  }

  private getTokenKey() {
    const tenantId = this.getTenantId();
    if (tenantId) return `${this.tokenKey}_${tenantId}`;
    return this.tokenKey;
  }
  getToken() {
    return this.store && this.store.getItem(this.getTokenKey());
  }
  setToken(token: string) {
    this.store && this.store.setItem(this.getTokenKey(), token);
  }
  removeToken() {
    this.store && this.store.removeItem(this.getTokenKey());
  }
}
export default new User();
